import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class IlanReklamTuruListeAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "IlanReklamTuruListe";
    super(baseUrl);
  }


  getIlanReklamTuruListeListe(yili: number, butceGelirId?: number) {

    return this.get("", { params: { yili: yili, butceGelirId: butceGelirId } })


  }

}
export default new IlanReklamTuruListeAPI();
class IlanReklamTuruListeListeRequest {
  public Yili: number;
  public ButceGelirId?: number;
  constructor(yili: number, butceGelirId?: number) {
    this.Yili = yili;
    this.ButceGelirId = butceGelirId;

  }
}
export { IlanReklamTuruListeListeRequest };